import { Link } from "react-router-dom";

export default function StickyMobileCTA() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-acoe-bg/95 nav-blur border-t border-acoe-border px-4 py-3"
      data-testid="sticky-mobile-cta"
    >
      <Link
        to="/recruit/contact"
        className="flex items-center justify-center rounded-full bg-acoe-charcoal text-acoe-bg px-6 py-3 text-sm font-heading font-semibold tracking-wide hover:bg-acoe-gold transition-colors"
        data-testid="sticky-mobile-cta-button"
      >
        お問い合わせ
      </Link>
    </div>
  );
}
